var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chose-page-box",style:(_vm.flexDirection),attrs:{"id":"chosePageBox"}},_vm._l((_vm.allowBtn),function(item){return _c('div',{on:{"click":function($event){return _vm.choseItem(item)}}},[_c('img',{attrs:{"src":require(`@/assets/images/governmentAffairs/common/${item.imgName}${item.chosed == true ? '_c' : ''}.png`)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }